// disclosure.js
// Toggles a [data-disclosure] region between its collapsed and expanded content.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-disclosure-toggle]');
  if (!toggle) return;

  const root = toggle.closest('[data-disclosure]');
  const expanded = toggle.getAttribute('aria-expanded') !== 'true';

  toggle.setAttribute('aria-expanded', String(expanded));
  toggle.textContent = expanded ? toggle.dataset.labelExpanded : toggle.dataset.labelCollapsed;
  root.querySelectorAll('[data-disclosure-expanded]').forEach((el) => { el.hidden = !expanded; });
  root.querySelectorAll('[data-disclosure-collapsed]').forEach((el) => { el.hidden = expanded; });
});
